import { otherApiClient } from ".";
// 주문 유형 상수
export const OrderType = {
    SINGLE_PRODUCT: 0,
    MEMBERSHIP: 1,
    GOODNOTER: 2,
    ALADIN: 3,
    PASS: 4,
    SOLVOOK_PLUS: 5,
    EXPERT: 6,
    EXPERT_SUBSCRIPTION: 7,
    PACKAGE: 8,
    FREE_PASS: 9,
    BINDING: 10,
    SHIPPING: 11,
    CASH: 12,
    OPTION_UPGRADE: 13,
    SUBSCRIPTION: 14
};
export const OrderStatus = {
    ORDERED: 0,
    VBANK_WAITING: 100,
    BILLING_WAITING: 200,
    COMPLETE: 400,
    BILLING_FAILED: 800,
    CANCELED: 900,
    REFUND_SUCCESS: 1000,
    PARTIALLY_REFUND: 1100
};
export const OrderStatusWithString = {
    [OrderStatus.ORDERED]: "결제 대기",
    [OrderStatus.VBANK_WAITING]: "입금 대기중",
    [OrderStatus.BILLING_WAITING]: "입금 대기중",
    [OrderStatus.COMPLETE]: "결제 완료",
    [OrderStatus.BILLING_FAILED]: "결제 실패",
    [OrderStatus.CANCELED]: "결제 취소",
    [OrderStatus.REFUND_SUCCESS]: "환불 완료",
    [OrderStatus.PARTIALLY_REFUND]: "부분 환불"
};
export const DiscountTypes = {
    AMOUNT: "amount",
    PERCENT: "percent"
};
export const postOrder = async (params)=>{
    const { data  } = await otherApiClient.market.post("/orders", params);
    return data;
};
export const getBooksOrderList = async (params)=>{
    const { data  } = await otherApiClient.market("/orders", {
        params
    });
    return data;
};
export const getOrderList = async (param)=>{
    let { id , token  } = param;
    const headers = {};
    if (token) {
        headers.Authorization = token;
    }
    const { data  } = await otherApiClient.market("/orders/".concat(id), {
        headers
    });
    return data;
};
export const patchOrder = async (params)=>{
    const { id , ...rest } = params;
    const { data  } = await otherApiClient.market.patch("/orders/".concat(id), rest);
    return data;
};
export const checkPurchasePolicy = async (params)=>{
    const { data  } = await otherApiClient.market.get("/purchase-policy/check", {
        params
    });
    return data;
};
